// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1KjxF","question":"Question_question__N1TCQ","description":"Question_description__3tfna"};